import React from "react";

const ContentRealization = ({post}) => {

    const {id, link, image, excerpt, title, terms} = post;

    // Pobranie danych z terms, zapewniając, że nie są one undefined
    const realizationType = terms?.typ_realizacji || [];
    const usedTechnology = terms?.uzyta_technologia || [];


    return (
        <div id={`post-${id}`} className="content-realization">
            <div className="content-realization--inside">
                <a href={link} className="content-realization__link" rel="noopener noreferrer">
                    <div className="content-realization--inside__image">

                        <div className="realization--type">
                            {realizationType.map((type, index) => (
                                <span key={`type-${index}`}>
                                    {type.name}
                                </span>
                            ))}
                        </div>

                        <div className="realization--technology">
                            {usedTechnology.map((tech, index) => (
                                <img key={`tech-${index}`} src={tech.acf.technology_icon.url} alt={tech.acf.technology_icon.alt}/>
                            ))}
                        </div>

                        <div dangerouslySetInnerHTML={{__html: image}}></div>
                        <div className="content-realization--inside__content">
                            <h3 className="content-realization__title">{title}</h3>
                            <span>{excerpt}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default ContentRealization;
